module.exports = __webpack_public_path__ + "static/media/Avatars_Other-22.d6e39670.png";